import * as React from 'react';
import {
    Create,
    TextInput,
    required,
    SimpleForm,
    DateInput,
    SelectInput,
    ReferenceInput,
    minValue,
    useDataProvider,
    DataProviderContext,
    NumberInput,
} from 'react-admin';
import FileUpload from '../../common/inputs/FileUpload';

import { useParams } from 'react-router';
import { LoadingSection } from '../../common/LoadingSection';
import HTMLEditorInput, { validHtml } from '../../common/inputs/HTMLEditorInput';
import { createCustomGoDataProvider } from '../../services';
import { STATUSES } from '../../common/constants';

const ProductTemplatesCreate = () => {
    let { categoryId } = useParams();
    if (!categoryId) {
        return <LoadingSection />;
    }
    const baseDataProvider = useDataProvider();
    const customDataProvider = React.useMemo(
        () =>
            createCustomGoDataProvider(baseDataProvider, [
                { resource: 'ecom_product_templates', apiEndpoint: '/ecom/product-templates' },
            ]),
        [baseDataProvider],
    );
    return (
        <DataProviderContext.Provider value={customDataProvider}>
            <Create
                resource={'ecom_product_templates'}
                redirect={(e: any, id: any) => {
                    return `ecom_categories/${categoryId}/ecom_product_templates`;
                }}
            >
                <SimpleForm defaultValues={{ categoryId: categoryId }}>
                    <FileUpload type="VIDEO_THUMBNAIL" source="images" multiple />
                    <TextInput source="name" fullWidth validate={[required()]} />
                    <NumberInput
                        source="heightInMtr"
                        prefix={'In Meters'}
                        fullWidth
                        validate={[required(), minValue(0)]}
                    />
                    <SelectInput
                        source="status"
                        label={'Status'}
                        fullWidth
                        validate={[required()]}
                        choices={STATUSES}
                    />
                    <NumberInput
                        source="widthInMtr"
                        prefix={'In Meters'}
                        fullWidth
                        validate={[required(), minValue(0)]}
                    />
                    <NumberInput
                        source="lengthInMtr"
                        prefix={'In Meters'}
                        fullWidth
                        validate={[required(), minValue(0)]}
                    />
                    <NumberInput
                        source="weightInGrams"
                        prefix={'In Grams'}
                        fullWidth
                        validate={[required(), minValue(0)]}
                    />
                    <TextInput
                        source="textDescription"
                        multiline
                        rows={4}
                        fullWidth
                        validate={[required()]}
                    />
                    <HTMLEditorInput
                        source={'htmlDescription'}
                        fullWidth
                        validate={[required(), validHtml]}
                    />
                </SimpleForm>
            </Create>
        </DataProviderContext.Provider>
    );
};

export default ProductTemplatesCreate;
